/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-named-as-default-member */
import { ToastContainer } from 'react-toastify';
import React, { Suspense } from 'react';
import { useRoutes } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Themeroutes from './routes/Router';
import ThemeSelector from './layouts/theme/ThemeSelector';
import Loader from './layouts/loader/Loader';
import IdleLogout from './components/idelLogout';

import "react-datepicker/dist/react-datepicker.css";

const App = () => {
  const routing = useRoutes(Themeroutes);
  const direction = useSelector((state) => state.customizer.isRTL);
  const isMode = useSelector((state) => state.customizer.isDark);
  return (
    <Suspense fallback={<Loader />}>
      <div
        className={`${direction ? 'rtl' : 'ltr'} ${isMode ? 'dark' : ''}`}
        dir={direction ? 'rtl' : 'ltr'}
      >
        <IdleLogout/>
        <ThemeSelector />
        {routing}
        <ToastContainer position="top-right" autoClose={2000} />
      </div>
    </Suspense>
  );
};

export default App;
